import { DeleteNode, GetLinkValue, NodeColor, NodeDisplayed, AssignLinkLocalAttribute, AssignNodeLocalAttribute, ReturnValueNode } from '../import/OpenSankey';
import * as d3 from 'd3';
import { afm_default_node } from './AFMSankeyMenu';
export const ArrangeTrade = (data, scale) => {
    const { nodes, links } = data;
    let import_nodes = [];
    if ('Niveau Echanges' in data.levelTags) {
        const level_selected = Object.values(data.levelTags['Niveau Echanges'].tags).filter(tag => tag.selected)[0].name;
        const res = Object.values(nodes).filter(n => {
            if (!n.tags['Type de noeud']) {
                return false;
            }
            if (n.tags['Type de noeud'].length === 0) {
                return false;
            }
            if (n.tags['Type de noeud'][0] === 'echange') {
                return true;
            }
            return false;
        }).filter(n => {
            if (!('dimensions' in n)) {
                return false;
            }
            if (!('Niveau Echanges' in n.dimensions)) {
                return false;
            }
            if (!('Niveau Echanges' in n.tags)) {
                return false;
            }
            const selected = n.tags['Niveau Echanges'].filter(tag => tag.includes(level_selected)).length > 0;
            if (!selected) {
                return false;
            }
            if (n.outputLinksId.length == 0) {
                return false;
            }
            return true;
        });
        import_nodes = import_nodes.concat(res);
    }
    else {
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) && n.tags['Type de noeud'][0] == 'echange' && n.outputLinksId.length > 0);
        import_nodes = import_nodes.concat(res);
    }
    import_nodes = [...new Set(import_nodes)];
    let export_nodes = [];
    if ('Niveau Echanges' in data.levelTags) {
        const level_selected = Object.values(data.levelTags['Niveau Echanges'].tags).filter(tag => tag.selected)[0].name;
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) && n.tags['Type de noeud'][0] == 'echange').filter(n => {
            if (!('dimensions' in n)) {
                return false;
            }
            if (!('Niveau Echanges' in n.dimensions)) {
                return false;
            }
            if (!('Niveau Echanges' in n.tags)) {
                return false;
            }
            const selected = n.tags['Niveau Echanges'].filter(tag => tag.includes(level_selected)).length > 0;
            if (!selected) {
                return false;
            }
            if (n.inputLinksId.length == 0) {
                return false;
            }
            return true;
        });
        export_nodes = export_nodes.concat(res);
    }
    else {
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) && n.tags['Type de noeud'][0] == 'echange' && n.inputLinksId.length);
        export_nodes = export_nodes.concat(res);
    }
    export_nodes = [...new Set(export_nodes)];
    const import_nodes_close = import_nodes.filter(n => n.trade_close);
    const export_nodes_close = export_nodes.filter(n => n.trade_close);
    import_nodes_close.forEach(node => {
        const output_link = links[node.outputLinksId[0]];
        if (!output_link) {
            return;
        }
        //const output_node = nodes[output_link.idTarget]
        node.position = 'relative';
        node.x = -data.trade_close_hspace;
        node.y = -data.trade_close_vspace;
        AssignNodeLocalAttribute(node, 'label_visible', false);
        AssignNodeLocalAttribute(node, 'shape_visible', false);
        node.y_label = node.y + +ReturnValueNode(data, node, 'node_width');
        // node.y_label = node.y+ +(data.node_width)
        //AssignLinkLocalAttribute(output_link,'label_position','frozen'
        AssignLinkLocalAttribute(output_link, 'orientation', 'vh');
        AssignLinkLocalAttribute(output_link, 'label_position', 'end');
        AssignLinkLocalAttribute(output_link, 'label_on_path', true);
        //AssignLinkLocalAttribute(output_link,'text_color','white'
        AssignLinkLocalAttribute(output_link, 'label_visible', true);
    });
    export_nodes_close.forEach((node) => {
        const input_link = links[node.inputLinksId[0]];
        node.position = 'relative';
        node.x = data.trade_close_hspace;
        node.y = data.trade_close_vspace;
        AssignNodeLocalAttribute(node, 'label_visible', false);
        AssignNodeLocalAttribute(node, 'shape_visible', false);
        node.y_label = node.y + 10;
        AssignLinkLocalAttribute(input_link, 'orientation', 'hv');
        AssignLinkLocalAttribute(input_link, 'label_visible', true);
        AssignLinkLocalAttribute(input_link, 'label_position', 'beginning');
        AssignLinkLocalAttribute(input_link, 'label_on_path', true);
        //AssignLinkLocalAttribute(input_link,'text_color','white'
        AssignLinkLocalAttribute(input_link, 'label_visible', true);
        // d3.select('#ggg_'+node.idNode + ' text')
        //   .attr('text-anchor', 'left')
    });
    // Trade at the top and bottom
    const import_nodes_outside = import_nodes.filter(n => !n.trade_close);
    const export_nodes_outside = export_nodes.filter(n => !n.trade_close);
    const nb_import = {};
    const nb_export = {};
    let prev_y = {};
    const link_x = {};
    let max_vertical_offset = 0;
    const compute_offset = (node) => {
        if (!node.y) {
            return;
        }
        if ('Type de noeud' in node.tags && node.tags['Type de noeud'] && node.tags['Type de noeud'][0] == 'echange' && node.inputLinksId.length > 0) {
            return;
        }
        max_vertical_offset = Math.max(node.y, max_vertical_offset);
    };
    Object.values(nodes).filter(n => NodeDisplayed(data, n)).forEach(compute_offset);
    max_vertical_offset = max_vertical_offset + 200;
    import_nodes_outside.forEach((node) => {
        node.position = 'absolute';
        AssignNodeLocalAttribute(node, 'label_visible', true);
        AssignNodeLocalAttribute(node, 'shape_visible', false);
        const output_link = links[node.outputLinksId[0]];
        AssignLinkLocalAttribute(output_link, 'text_color', NodeColor(nodes[output_link.idTarget], data));
        // x position
        const target_node = nodes[output_link.idTarget];
        const x = Math.round(target_node.x / data.h_space) * data.h_space - data.trade_hspace;
        const xstr = x.toString();
        if (!(xstr in nb_import)) {
            nb_import[xstr] = 0;
        }
        nb_import[xstr] = nb_import[xstr] + 1;
        // node x position
        node.x = x;
        // node label x position
        // const d3_node = d3.select('#ggg_'+node.idNode+ ' text').node()
        // Search for the g nod element since it can be present but not the text
        const d3_node = d3.select('#shape_' + node.idNode).node();
        if (!d3_node) {
            return;
        }
        // const l = (d3_node as SVGTSpanElement).getComputedTextLength()
        // Since we want the node to be extremely thin (widely) the node width is 0
        const l = 0;
        // link label x position preprocessing
        const node_x_str = x.toString();
        if (!(node_x_str in link_x)) {
            link_x[node_x_str] = node.x - l;
        }
        const html_node = d3.select('#text_' + node.outputLinksId[0]).node();
        if (!html_node) {
            return;
        }
        const link_value_length = html_node.getComputedTextLength();
        link_x[node_x_str] = Math.min(node.x - l - link_value_length - 2, link_x[node_x_str]);
        // y position
        if (!(xstr in prev_y)) {
            prev_y[xstr] = 20;
        }
        // const h = (d3.select('#ggg_'+node.idNode+ ' text').node() as SVGTSpanElement).getBBox().height
        const h = scale(GetLinkValue(data, output_link.idLink).value);
        const y = prev_y[xstr];
        prev_y[xstr] = y + Math.max(scale(GetLinkValue(data, output_link.idLink).value), h) + 5;
        // node y position
        node.y = y;
        AssignNodeLocalAttribute(node, 'label_box_width', 300);
        // node label y position
        node.y_label = undefined; //scale(GetLinkValue(data,output_link.idLink).value)/2 + h/3
        node.x_label = undefined;
        output_link.y_label = node.y + h / 2 - (+ReturnValueNode(data, node, 'font_size'));
        AssignNodeLocalAttribute(node, 'label_horiz', 'left');
        AssignNodeLocalAttribute(node, 'label_vert', 'middle');
        AssignNodeLocalAttribute(node, 'node_width', 0);
        //node.display_style.label_color = NodeColor(nodes[output_link.idTarget],data)
    });
    Object.keys(nb_import).forEach(xstr => import_nodes.filter(n => n.x === +xstr).forEach((n) => {
        // const left_shift = data.trade_left_shift-(i/nb_import[n.x])*data.trade_max_shift
        const left_shift = data.trade_left_shift;
        AssignLinkLocalAttribute(links[n.outputLinksId[0]], 'left_horiz_shift', left_shift);
        // const right_shift = data.trade_right_shift-(i/nb_import[n.x])*data.trade_max_shift
        const right_shift = data.trade_right_shift;
        AssignLinkLocalAttribute(links[n.outputLinksId[0]], 'right_horiz_shift', right_shift);
    }));
    import_nodes_outside.forEach((node) => {
        const output_link = links[node.outputLinksId[0]];
        const node_x_str = node.x.toString();
        output_link.x_label = link_x[node_x_str];
        AssignLinkLocalAttribute(output_link, 'label_position', 'frozen');
        AssignLinkLocalAttribute(output_link, 'curvature', 1);
        AssignLinkLocalAttribute(output_link, 'orientation', 'hh');
        AssignLinkLocalAttribute(output_link, 'label_visible', true);
        if (GetLinkValue(data, output_link.idLink).value === 0) {
            AssignLinkLocalAttribute(output_link, 'label_visible', false);
        }
        d3.select('#ggg_' + node.idNode + ' text')
            .selectAll('tspan')
            .attr('text-anchor', 'end');
    });
    prev_y = {};
    export_nodes_outside.forEach((node) => {
        node.position = 'absolute';
        AssignNodeLocalAttribute(node, 'label_visible', true);
        AssignNodeLocalAttribute(node, 'shape_visible', false);
        const input_link = links[node.inputLinksId[0]];
        AssignLinkLocalAttribute(input_link, 'text_color', NodeColor(nodes[input_link.idSource], data));
        const source_node = nodes[input_link.idSource];
        if (!NodeDisplayed(data, source_node)) {
            return;
        }
        const x = Math.round(source_node.x / data.h_space) * data.h_space + data.trade_hspace;
        const xstr = x.toString();
        if (!(xstr in nb_export)) {
            nb_export[xstr] = 0;
        }
        if (!(xstr in prev_y)) {
            prev_y[xstr] = max_vertical_offset;
        }
        nb_export[xstr] = nb_export[xstr] + 1;
        // const d3_node = d3.select('#ggg_'+node.idNode+ ' text').node()
        const d3_node = d3.select('#shape_' + node.idNode).node();
        if (!d3_node) {
            return;
        }
        // const l = (d3_node as SVGTSpanElement).getComputedTextLength()
        const l = 0;
        // const h = (d3_node as SVGTSpanElement).getBBox().height
        const h = +d3.select('#shape_' + node.idNode).attr('height');
        const y = prev_y[xstr];
        prev_y[xstr] = y + h;
        node.x = x;
        AssignNodeLocalAttribute(node, 'label_box_width', 300);
        node.y = y;
        AssignNodeLocalAttribute(node, 'label_horiz', 'right');
        AssignNodeLocalAttribute(node, 'label_vert', 'middle');
        AssignNodeLocalAttribute(node, 'node_width', 0);
        node.y_label = undefined;
        node.x_label = undefined;
        const node_x_str = x.toString();
        if (!(node_x_str in link_x)) {
            link_x[node_x_str] = node.x + l;
        }
        link_x[node_x_str] = Math.max(node.x + l / 2 + l, link_x[node_x_str]);
        input_link.y_label = node.y + h / 2 - (+ReturnValueNode(data, node, 'font_size'));
    });
    Object.keys(nb_export).forEach(xstr => export_nodes.filter(n => n.x === +xstr).forEach((n) => {
        // const left_shift = data.trade_left_shift-(i/nb_export[n.x])*data.trade_max_shift
        const left_shift = data.trade_left_shift;
        AssignLinkLocalAttribute(links[n.inputLinksId[0]], 'left_horiz_shift', left_shift);
        // const right_shift = data.trade_right_shift-(i/nb_export[n.x])*data.trade_max_shift
        const right_shift = data.trade_right_shift;
        AssignLinkLocalAttribute(links[n.inputLinksId[0]], 'right_horiz_shift', right_shift);
    }));
    export_nodes_outside.forEach((node) => {
        const input_link = links[node.inputLinksId[0]];
        if (!input_link) {
            return;
        }
        const node_x_str = node.x.toString();
        input_link.x_label = link_x[node_x_str];
        AssignLinkLocalAttribute(input_link, 'label_position', 'frozen');
        AssignLinkLocalAttribute(input_link, 'curvature', 1);
        AssignLinkLocalAttribute(input_link, 'orientation', 'hh');
        AssignLinkLocalAttribute(input_link, 'label_visible', true);
        d3.select('#ggg_' + node.idNode + ' text')
            .selectAll('tspan')
            .attr('text-anchor', 'left');
    });
};
// Fonctions d'individualisation des imports/exports
export const SplitIOrE = (node, trade_name, importation, data) => {
    //const originalIdNode = node.idNode
    let tmp = [];
    let tmp1;
    if (importation) {
        tmp = node.outputLinksId.slice(); // clone
        tmp1 = 'idTarget';
    }
    else {
        tmp = node.inputLinksId.slice(); // clone
        tmp1 = 'idSource';
    }
    tmp.forEach((idLink) => {
        const input_or_output_link = data.links[idLink];
        //input_or_output_link.visible = true
        const le_nom = data.nodes[input_or_output_link[tmp1]].name + ' - ' + trade_name;
        let idTrade = data.nodes[input_or_output_link[tmp1]].idNode + '-' + trade_name;
        idTrade = idTrade.replaceAll(' ', '');
        data.nodes[idTrade] = afm_default_node(data);
        data.nodes[idTrade]['name'] = le_nom;
        data.nodes[idTrade]['idNode'] = idTrade;
        data.nodes[idTrade]['tags'] = JSON.parse(JSON.stringify(node.tags));
        data.nodes[idTrade]['dimensions'] = Object.assign({}, node.dimensions);
        const new_node = data.nodes[idTrade];
        if (importation) {
            const link = data.links[idLink];
            if (!link) {
                return;
            }
            link.idSource = new_node.idNode;
            const target_node = data.nodes[link.idTarget];
            Object.keys(target_node.dimensions).forEach(dim_key => {
                new_node.dimensions[dim_key] = JSON.parse(JSON.stringify(target_node.dimensions[dim_key]));
            });
            Object.keys(target_node.tags).forEach(tag_key => {
                if (tag_key === 'Type de noeud') {
                    return;
                }
                const tags = [...target_node.tags[tag_key]];
                if (tag_key in new_node.tags) {
                    new_node.tags[tag_key] = [...new Set(new_node.tags[tag_key].concat(tags))];
                }
            });
            //new_node['tags']['Type de noeud'] = ['echange']
            new_node.outputLinksId.push(idLink);
        }
        else {
            const link = data.links[idLink];
            if (!link) {
                return;
            }
            link.idTarget = new_node.idNode;
            const source_node = data.nodes[link.idSource];
            Object.keys(source_node.dimensions).forEach(dim_key => {
                new_node.dimensions[dim_key] = JSON.parse(JSON.stringify(source_node.dimensions[dim_key]));
            });
            Object.keys(source_node.tags).forEach(tag_key => {
                if (tag_key === 'Type de noeud') {
                    return;
                }
                const tags = [...source_node.tags[tag_key]];
                if (tag_key in new_node.tags) {
                    new_node.tags[tag_key] = [...new Set(new_node.tags[tag_key].concat(tags))];
                }
            });
            //new_node['tags']['Type de noeud'] = ['echange']
            new_node.inputLinksId.push(idLink);
        }
    });
    node.inputLinksId = [];
    node.outputLinksId = [];
};
export const SplitTrade = (trade_name, data) => {
    const { nodes } = data;
    // e.g. "International"
    let node;
    Object.keys(nodes).forEach(node_key => {
        if (node_key === trade_name) {
            node = nodes[node_key];
        }
    });
    if (node === undefined) {
        return -1;
    }
    if (node.outputLinksId.length > 0) { // Imports
        SplitIOrE(node, trade_name, true, data);
        DeleteNode(data, node);
        Object.values(data.nodes).filter(n => n.name.includes(trade_name)).forEach(n => {
            if (n.outputLinksId.length == 0) {
                return;
            }
            const target_node = data.nodes[data.links[n.outputLinksId[0]].idTarget];
            Object.keys(target_node.dimensions).forEach(key => {
                if (!target_node.dimensions[key].parent_name) {
                    return;
                }
                const parent_name = data.nodes[target_node.dimensions[key].parent_name].name.split(' - ')[0] + ' - ' + trade_name;
                if (Object.values(data.nodes).filter(n => n.name === parent_name).length > 0) {
                    n.dimensions[key].parent_name = Object.values(data.nodes).filter(n => n.name === parent_name)[0].idNode;
                }
            });
        });
    }
    if (node.inputLinksId.length > 0) { // Exports
        SplitIOrE(node, trade_name, false, data);
        DeleteNode(data, node);
        Object.values(data.nodes).filter(n => n.name.includes(trade_name)).forEach(n => {
            if (n.inputLinksId.length == 0) {
                return;
            }
            const source_node = data.nodes[data.links[n.inputLinksId[0]].idSource];
            Object.keys(source_node.dimensions).forEach(key => {
                if (!source_node.dimensions[key].parent_name) {
                    return;
                }
                const parent_name = data.nodes[source_node.dimensions[key].parent_name].name.split(' - ')[0] + ' - ' + trade_name;
                if (Object.values(data.nodes).filter(n => n.name === parent_name).length > 0) {
                    n.dimensions[key].parent_name = Object.values(data.nodes).filter(n => n.name === parent_name)[0].idNode;
                }
            });
        });
    }
    return node.idNode;
};
